<template>
  <div>
    <vx-card title="Define tus criterios para invertir automáticamente.">
      <div class="vx-row">
        <div class="vx-col xxl:w-3/4 w-full">
          <p>Estos criterios afectan únicamente tus inversiones automatizadas y podrán modificarse en
            cualquier momento conforme a tus necesidades o preferencias de riego.</p>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col xxl:w-3/4 w-full">
          <p class="mt-4 mb-1">
            <span class="bold">Monto mínimo de inversiones automatizadas:</span> {{explicitMoneyFormat(this.investorPlan.min_autoinvest_project_amount_mxn)}}
          </p>
          <p class="mt-4 mb-1">
            <span class="bold">Monto máximo de inversiones automatizadas:</span> {{explicitMoneyFormat(this.investorPlan.max_autoinvest_project_amount_mxn)}}
          </p>
        </div>
      </div>
    </vx-card>

    <!-- VISTAS DE CONFIGURACION -->

    <projects-qualification-set
      v-if="isMounted"
      :investor-plan="investorPlan"
      @on-saved="onProjectsQualificationsSaved"
      @on-cancel="backToMain"
      :investor-id="InvestorId"
    />
    <!-- FIN VISTAS DE CONFIGURACION -->

  </div>
</template>

<script>
import ProjectsQualificationSet from "@/views/admin/investor/plans/ProjectsQualificationSet";
import formatHelper from "@mixins/formatHelper";
export default {
  components: {
    ProjectsQualificationSet
  },
  mixins:[formatHelper],
  data(){
    return {
      autoInvestPayments: false,
      monthlyAutoInvest: false,
      investLimitsActive: true,

      currentMainView: 0,
      currentSubView: null,
      minAutoInvestPercent: 50,
      maxAutoInvestPercent: 100,

      currentAutoInvestPercent: 100,
      widthx: 60,
      heightx: 60,

      investorPlan: {
        id: null,
        card_id: null,
        card_amount: null,
        reinvestment_percentage: null,
        qualifications: null,
        monthly_day: null,
        available_money: null,
        retry: null,
        min_autoinvest_project_amount_mxn: null,
        max_autoinvest_project_amount_mxn: null,
        autoinvest_applicant_payments: null,
        autoinvest_deposits: null,
      },

      finalBalance: null,
      minAutoInvestMxn: null,

      isBusy: false,
      isMounted: false,
      InvestorId: null,
    }
  },
  async beforeMount(){
    this.InvestorId = this.$route.params.id;
    this.showLoading(true);
    this.isMounted = false
    await this.loadPrefs();
    this.isMounted = true
    this.showLoading(false);
  },
  methods: {
    percentUpdated(value){
      const v = 60 + ((value - 50) * 0.5);
      this.widthx = this.heightx = v;
    },
    async loadPrefs(){
      await this.getPlansInfo();
      await this.setDefaults();
    },
    async getPlansInfo(){
      try {
        const res = await axios.get(`api/v2/investor/${this.InvestorId}/getInvestorPlansInfo`);
        this.investorPlan = res.data.plan;
        this.finalBalance = res.data.finalBalance;
        this.minAutoInvestMxn = res.data.minAutoInvestMxn;

        if(this.investorPlan.min_autoinvest_project_amount_mxn === null
          || this.investorPlan.min_autoinvest_project_amount_mxn === 0){
          this.investorPlan.min_autoinvest_project_amount_mxn = this.minAutoInvestMxn;
        }

        if(this.investorPlan.max_autoinvest_project_amount_mxn === null){
          this.investorPlan.max_autoinvest_project_amount_mxn = 0;
        }
      }
      catch (e) {
      }
    },
    async saveOption(key, val, name){
      this.showLoading(true)
      let success = false;
      try {
        let payload = { option_key: key, option_value: val };
        await axios.post(`api/v2/investor/${this.InvestorId}/setAutoInvestOptions`, payload);
        let mssg = name;
        mssg += (val) ? ' habilitada' : ' deshabilitada';
        mssg += ' exitosamente.';
        this.successNotif('Preferencia actualizada', mssg);
        success = true;
      }
      catch (e) {
        this.errorNotif('Error en guardado', 'No ha sido posible actualizar la información');
        success = false;
      }
      finally {
        await this.loadPrefs();
        this.showLoading(false)
      }
      return success;
    },
    async setAvailableMoney(){
      await this.getPlansInfo();
      this.currentMainView = 1;
      this.currentSubView = 2;
    },
    async setInvestmentLimits(){
      await this.getPlansInfo();
      this.currentMainView = 1;
      this.currentSubView = 3;
    },
    async setProjectQualifications(){
      await this.getPlansInfo();
      this.currentMainView = 1;
      this.currentSubView = 4;
    },

    async onMonthlyInvestSaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },
    async onAvailableMoneySaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },
    async onInvestmentLimitsSaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },
    async onProjectsQualificationsSaved(){
      await this.loadPrefs();
      this.currentMainView = 0;
    },

    async backToMain(){
      this.currentMainView = 0;
    },

    async setDefaults(){
      this.autoInvestPayments = this.investorPlan.autoinvest_applicant_payments === 1;
      this.monthlyAutoInvest = this.investorPlan.autoinvest_deposits === 1;

      //this.currentAutoInvestPercent = 100;
      //this.percentUpdated(this.currentAutoInvestPercent);
    },
  },
  computed: {
    onMainView(){
      return this.currentMainView === 0;
    },
    onSetsView(){
      return this.currentMainView === 1;
    },
    onMonthInvestSubview(){
      return this.currentSubView === 1;
    },
    onAvailableMoneySubview(){
      return this.currentSubView === 2;
    },
    onInvestmentLimitsSubView(){
      return this.currentSubView === 3;
    },
    onProjectQualificationsSubView(){
      return this.currentSubView === 4;
    },
    investmentPrefsActive(){
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    reinvestmentActive() {
      return this.autoInvestPayments === true;
    },
    cardInvestmentActive() {
      return this.monthlyAutoInvest === true;
    },
    showAvailableMoney(){
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    showInvestmentLimits() {
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    showProjectsQualifSets(){
      return this.monthlyAutoInvest === true || this.autoInvestPayments === true;
    },
    currentAvailableMoneyValue(){
      return this.investorPlan.available_money;
    },
    currentMinLimitValue(){
      return this.investorPlan.min_autoinvest_project_amount_mxn;
    },
    currentMaxLimitValue(){
      return this.investorPlan.max_autoinvest_project_amount_mxn;
    },
  }
}
</script>

<style lang="css">
.cuadrox {
  padding: 10px;
  background: rgb(45, 208, 129);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(255, 255, 255);
  font-size: 20px;
  border-radius: 10px;
}

.vx-card.disabled {
  opacity: 0.4;
}
</style>
